import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

// import ScrollMenu from "react-horizontal-scrolling-menu";

// import { loadProgressBar } from "axios-progress-bar";
// import queryString from "query-string";

import SearchBox from './SearchBox';
import moment from 'moment';
import { Base64 } from 'js-base64';

import ContentItem from '../../components/ContentItem';
// import InfiniteScroll from "react-infinite-scroll-component";

//import ProgressContainer from '../containers/ProgressContainer'

class SearchList extends Component {
  state = {
    gotoPage: 1,
    pageSize: 15,
    searchList: [],
    onOverWith: false,
  };
  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;

    //const { match } = this.props;
    //const strFind = match.params.st;
    // const { location } = this.props;
    //const query = queryString.parse(location.search);
    //const strFind = query.st
    ////console.log(strFind)

    const strFind = this.props.childProps.strFind;
    const g = this.props.childProps.g;
    const { gotoPage } = this.state;

    //console.log(strFind)

    window.addEventListener('scroll', this._scrollPage);
    document.addEventListener('touchmove', this._scrollPage);

    if (strFind === null || strFind === undefined || strFind === '') {
    } else {
      this._getSearchData(gotoPage, strFind);
    }

    /*
        this.setState({
            strFind
        })
        */
  };
  componentWillUnmount() {
    this._isMounted = false;
    window.scrollTo(0, 0);
    window.removeEventListener('scroll', this._scrollPage);
    document.removeEventListener('touchmove', this._scrollPage);
  }

  _scrollPage = () => {
    // const strFind = this.props.childProps.strFind;
    const { gotoPage } = this.state;
    const windowHeight =
      'innerHeight' in window
        ? window.innerHeight
        : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    const windowBottom = windowHeight + window.pageYOffset;
    if (windowBottom >= docHeight - 150) {
      const strFind = this.props.childProps.strFind;
      this._getSearchData(gotoPage, strFind);
    } else {
      //console.log('not bottom')
    }
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    ////console.log(this.props.location.pathname)
    ////console.log(nextProps.location)
    return this.props.childProps.strFind !== nextProps.childProps.strFind;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    if (this.props.childProps.strFind !== nextProps.childProps.strFind) {
      this._getSearchData(1, nextProps.childProps.strFind);
    }
  };
  _getSearchData = async (gotoPage, strFind) => {
    const result = await this._getSearchDataApi(gotoPage, strFind);
    const intReturn = result.data[0].intReturn;
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const searchList = result.data[0].listData;

    if (this._isMounted) {
      if (intReturn === 0) {
        if (con > 0) {
          this.setState({
            gotoPage: gotoPage + 1,
            con: con,
            searchList:
              gotoPage === 1
                ? searchList
                : this.state.searchList.concat(searchList),
            hasMore: pageCount < gotoPage ? false : true,
            strFind: strFind,
          });
        } else {
          this.setState({
            gotoPage: 1,
            con: con,
            searchList: searchList,
            hasMore: pageCount < gotoPage ? false : true,
            strFind: strFind,
          });
        }
      } else {
        this.setState({
          gotoPage: 1,
          con: con,
          searchList: searchList,
          hasMore: pageCount < gotoPage ? false : true,
          strFind: strFind,
        });
      }
    }
  };
  _getSearchDataApi = (gotoPage, strFind) => {
    const { apiUrl, loginId } = this.props;

    let token = new Date();
    token = moment(token).format('YYYYMMDDhhmmss');
    token = Base64.encode(token);
    //console.log(token)
    ////console.log(strFind)
    ////console.log(apiUrl + '/search?strFind=' + strFind + '&gotoPage=' + gotoPage + '&loginId=' + loginId)
    return axios
      .post(apiUrl + '/search', {
        params: {
          userid: loginId,
          strFind: strFind,
          gotoPage: gotoPage,
          token: token,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });

    /*
        return axios(apiUrl + '/search?strFind=' + strFind + '&gotoPage=' + gotoPage + '&loginId=' + loginId)
        .then(response => response)
        .catch(error => {
            //console.log('검색오류...')
        })
        */
  };

  _renderItem = () => {
    const { searchList } = this.state;

    const list = searchList.map((item, index) => {
      return (
        <div style={{ display: 'inline-block' }} key={index}>
          <ContentItem
            refer={'search'}
            contentSerial={item.contentSerial}
            title={item.title}
            genreName={item.genreName}
            img={item.img}
            overImg={item.overImg}
            restrictionCode={item.restrictionCode}
            opening={item.opening}
            director={item.director}
            contentSysnopsis={item.contentSysnopsis}
            wishFlag={item.wishFlag}
            contentPartSerial={item.contentPartSerial}
            onChangeWidth={this._onChangeWidth}
            cashOnly={item.cashOnly}
          />
        </div>
      );
    });

    return list;
  };

  _onChangeWidth = (num, over) => {
    //console.log('over...')
    this.setState({
      onOverWith: over,
    });
  };
  _renderBox = () => {
    const { con, searchList } = this.state;
    //console.log(con)

    let temp = [];

    for (let i = 0; i < con; i = i + 6) {
      temp.push(
        <SearchBox
          searchList={searchList.filter((item, index) => {
            return index >= i && index < i + 6;
          })}
          key={i}
        />
      );
    }

    const list = temp.map((item, index) => {
      return item;
    });
    return list;
  };

  render() {
    const { strFind, searchList, con } = this.state;
    ////console.log(searchList)
    return (
      <Fragment>
        <div className="content" style={{ position: 'relative' }}>
          <div
            className="vod_list_right vod_list_padding0"
            style={{ marginTop: 0 }}
          >
            <div className="vod_list_group">
              <h1>
                <em>"{strFind}"</em>에 대한 검색 결과 <span>({con})</span>
              </h1>

              <div className="vod_vod_list">
                <div className="main_list_goup2">
                  {searchList ? this._renderBox() : null}
                  {/*
                                    <div className="div_ul">
                                    <InfiniteScroll
                                        dataLength={this.state.searchList.length}
                                        next={() => this._getSearchData(gotoPage, strFind)}
                                        hasMore={ hasMore }
                                        loader={<div className="vod_loading"><img src="/img/vod/vod_loading.png"/></div>}
                                        style={{overflow: 'hidden', textAlign: 'center'}}
                                        endMessage={
                                            <p style={{textAlign: 'center'}}>
                                            
                                            </p>
                                        }
                                    >
                                    { searchList ? this._renderItem() : null}
                                    </InfiniteScroll> 
                                    </div>
                                    */}
                  <div className="clear"></div>
                </div>
                {/*<div className="vod_baner1"><Link to="/ticket"><img src="/img/vod/ee.png"/></Link></div>*/}
              </div>

              {/*<div className="vod_loading"><img src="img/vod/vod_loading.png"/></div>*/}
            </div>
          </div>
          <div className="clear"></div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(SearchList));
